/* eslint-disable no-useless-computed-key */
import cl from 'classnames'
import { FC, useState } from 'react'

import { Menu } from '@services/api/menus'

import styles from './desktop.module.scss'
import { MenuContentMercadoLivre } from './components/menu-content-mercado-livre'
import { MenuContentWithSubItems } from './components/menu-content-with-sub-items'
import { MenuContentProjetos } from './components/menu-content-projetos'
import { MenuContentNoticias } from './components/menu-content-noticias'
import { MenuContentOMUsinasSolares } from './components/menu-content-om-usinas-solares'

type MenuContentNames =
  | 'Mercado Livre'
  | 'Notícias'
  | 'Guia Solar'
  | 'Calculadora'
  | 'Cursos de Energia Solar'
  | 'O&M Usinas Solares'

type MenuContentProps = Record<MenuContentNames, number>

const menuContentHeight: MenuContentProps = {
  'Mercado Livre': 240,
  ['Notícias']: 245,
  'Guia Solar': 232,
  ['Calculadora']: 240,
  'Cursos de Energia Solar': 232,
  ['O&M Usinas Solares']: 240
}

export const MenuDesktop: FC<{ content: Menu[] }> = ({ content }) => {
  const [openMenu, setOpenMenu] = useState(content?.[0])

  return (
    <div className="w-full flex flex-col">
      <div className="w-full h-8 xl:h-10 flex justify-between gap-6 xl:gap-10">
        {content.map(menu => (
          <div
            key={`menu-item-${menu.id}`}
            onClick={() => setOpenMenu(menu)}
            className={cl('h-full cursor-pointer', {
              [styles.titleContainerOpened]: openMenu.id === menu.id
            })}
          >
            <span
              className={cl(styles.title, {
                [styles.titleOpened]: openMenu.id === menu.id
              })}
            >
              {menu.description}
            </span>
          </div>
        ))}
      </div>
      <div
        className={cl(
          'relative flex flex-wrap gap-x-10 gap-y-8 mt-8 transition-height duration-500'
        )}
        style={{
          height: menuContentHeight[openMenu.description]
        }}
      >
        <>
          <MenuContentMercadoLivre
            className={cl(
              'lg:absolute lg:opacity-0 lg:pointer-events-none transition-opacity duration-500',
              {
                'lg:opacity-100 lg:pointer-events-auto':
                  openMenu.description === 'Mercado Livre'
              }
            )}
          />
          <MenuContentNoticias
            openMenu={openMenu}
            className={cl('lg:absolute lg:opacity-0 lg:pointer-events-none', {
              'lg:opacity-100 lg:pointer-events-auto':
                openMenu.description === 'Notícias'
            })}
          />
          <MenuContentWithSubItems
            menus={openMenu?.menus}
            className={cl('lg:absolute lg:opacity-0 lg:pointer-events-none', {
              'lg:opacity-100 lg:pointer-events-auto':
                openMenu.description === 'Guia Solar'
            })}
          />
          <MenuContentProjetos
            className={cl(
              'lg:absolute lg:opacity-0 lg:pointer-events-none transition-opacity duration-500',
              {
                'lg:opacity-100 lg:pointer-events-auto':
                  openMenu.description === 'Calculadora'
              }
            )}
          />
          <MenuContentWithSubItems
            menus={openMenu?.menus}
            className={cl('lg:absolute lg:opacity-0 lg:pointer-events-none', {
              'lg:opacity-100 lg:pointer-events-auto':
                openMenu.description === 'Cursos de Energia Solar'
            })}
          />
          <MenuContentOMUsinasSolares
            className={cl(
              'lg:absolute lg:opacity-0 lg:pointer-events-none transition-opacity duration-500',
              {
                'lg:opacity-100 lg:pointer-events-auto':
                  openMenu.description === 'O&M Usinas Solares'
              }
            )}
          />
        </>
      </div>
    </div>
  )
}
